// routes
import { PATH_DASHBOARD } from './routes/paths';

// API
// ----------------------------------------------------------------------

export const FAST_API_URL = import.meta.env.VITE_FAST_API_URL?.replace('/v3', '') || '';
export const ROS_URL = import.meta.env.VITE_ROS_URL;
export const HOST_API_KEY = import.meta.env.VITE_HOST_API_KEY || '';

export const AUTH0_API = {
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
};

export const AUTH0_AUDIENCE = import.meta.env.VITE_AUTH0_AUDIENCE || '';

/**
 * The SDK caches tokens in memory by default, which is where they belong: localStorage is
 * readable by anything injected into the page. The offline end-to-end build is the one exception,
 * because a test seeds a session by writing that cache and an in-memory one is unreachable from
 * outside the app. Keyed on the build mode rather than a variable of its own, so a production
 * build cannot be handed this by accident.
 */
export const AUTH0_CACHE_LOCATION = import.meta.env.MODE === 'e2e' ? 'localstorage' : undefined;

export const ORGANIZATION = {
  name: import.meta.env.VITE_ORGANIZATION,
  id: import.meta.env.VITE_ORGANIZATION_ID,
};

export const INTERCOM_ID = import.meta.env.VITE_INTERCOM_ID || '';

export const MIXPANEL_TOKEN = import.meta.env.VITE_MIXPANEL_TOKEN || '';

export const DT_MIXPANEL_TOKEN = import.meta.env.VITE_DT_MIXPANEL_TOKEN || '';

export const MAPBOX_API_KEY = import.meta.env.VITE_MAPBOX_API || '';

export const MAGIC_BELL_TOKEN = import.meta.env.VITE_MAGIC_BELL_TOKEN;

export const VITE_ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT || 'local';

// embed takes the id, which is the last segment of a URL like
// https://form.typeform.com/to/<id>.
export const DIGITAL_CTV_TYPEFORM_ID = import.meta.env.VITE_DIGITAL_CTV_TYPEFORM_ID || '';

const configuredDataUploadMaxBytes = Number(import.meta.env.VITE_DATA_UPLOAD_MAX_FILE_BYTES);
export const DATA_UPLOAD_MAX_FILE_BYTES =
  Number.isFinite(configuredDataUploadMaxBytes) && configuredDataUploadMaxBytes > 0
    ? configuredDataUploadMaxBytes
    : 100 * 1024 * 1024;

// Bulk tagging a saved list or export writes one row per voter, so a mistaken
// statewide list turns into millions of writes. Numinar and DT admins can go over it.
const configuredBulkTaggingMaxVoters = Number(import.meta.env.VITE_BULK_TAGGING_MAX_VOTERS);
export const BULK_TAGGING_MAX_VOTERS =
  Number.isFinite(configuredBulkTaggingMaxVoters) && configuredBulkTaggingMaxVoters > 0
    ? configuredBulkTaggingMaxVoters
    : 1_000_000;

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = PATH_DASHBOARD.general.home; // as '/dashboard/app'

// LAYOUT
// ----------------------------------------------------------------------

export const DEFAULT_HEADER = {
  H_MOBILE: 64,
  H_MAIN_DESKTOP: 88,
  H_DASHBOARD_DESKTOP: 92,
  H_DASHBOARD_DESKTOP_OFFSET: 92 - 32,
};

export const DEFAULT_NAV = {
  W_BASE: 260,
  W_DASHBOARD: 280,
  W_DASHBOARD_MINI: 88,
  //
  H_DASHBOARD_ITEM: 42,
  H_DASHBOARD_ITEM_SUB: 36,
  //
  H_DASHBOARD_ITEM_HORIZONTAL: 32,
};

export const DEFAULT_ICON = {
  NAV_ITEM: 24,
  NAV_ITEM_HORIZONTAL: 22,
  NAV_ITEM_MINI: 22,
};
